module.exports = __webpack_public_path__ + "static/media/Dani.abf9c563.svg";